import isNumber from 'lodash.isnumber';

import {Integer} from '@pb/kit-component-formatters';

import type {Locale} from '@pb/kit-context-locale';

export const getCredits = (value: number | null = null, locale: Locale): string => {
    return isNumber(value) ? Integer.format(value, locale) : '';
};
